import { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { buildProductUrl, getCurrentRoute } from '../utils/navigation';

const SearchBox = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [keyword, setKeyword] = useState(searchParams.get('keyword') || '');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const fetchSuggestions = async (term) => {
    try {
      if (!term || term.trim().length < 2) {
        setSuggestions([]);
        setShowSuggestions(false);
        return;
      }

      const res = await fetch(
        `/api/products?keyword=${encodeURIComponent(term)}&pageNumber=1`
      );
      const data = await res.json();

      // adjust `.products` if your API shape is different
      const list = (data.products || []).slice(0, 6);
      setSuggestions(list);
      setShowSuggestions(list.length > 0);
    } catch (err) {
      console.error('Suggestion fetch error', err);
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    const currentKeyword = searchParams.get('keyword') || '';
    setKeyword(currentKeyword);
  }, [searchParams]);

  const submitHandler = (e) => {
    e.preventDefault();
    const term = keyword.trim();

    if (term) {
      navigate(`/results?keyword=${encodeURIComponent(term)}`);
    } else {
      navigate('/results');
    }
  };

  return (
    <div className="header-search-wrapper">
      <Form
        onSubmit={submitHandler}
        className="d-flex align-items-center header-search"
      >
        <Form.Control
          type="text"
          name="q"
          placeholder="Search products..."
          className="me-2"
          autoComplete="off"
          value={keyword}
          onChange={(e) => {
            const term = e.target.value;
            setKeyword(term);
            fetchSuggestions(term);
          }}
          onFocus={() => {
            if (suggestions.length > 0) setShowSuggestions(true);
          }}
          onBlur={() => {
            // small delay so click on dropdown still works
            setTimeout(() => setShowSuggestions(false), 150);
          }}
        />
        <Button type="submit" variant="outline-light" className="p-2">
          Search
        </Button>
      </Form>

      {showSuggestions && suggestions.length > 0 && (
        <div className="search-suggestions">
          {suggestions.map((p) => (
            <button
              type="button"
              key={p._id}
              className="search-suggestion-item"
              onMouseDown={() => {
                navigate(buildProductUrl(p._id, location), {
                  state: { from: getCurrentRoute(location) },
                });
              }}
            >
              {p.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBox;
